import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import Time from "../../../Time/Time";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import ChargeFactory from "../../../Entity/Factories/ChargeFactory";
import PaymentFactory from "../../../Entity/Factories/PaymentFactory";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import Constants from "../../../Action/Constants";
import ChargeUpdateDialog from "../../Partials/Dialog/ChargeUpdateDialog";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { EUR } from "../../../Currency/Currencies/EUR";
import * as uuidV4 from "uuid/v4";
import Memo from "../../Partials/Memo/Memo";

import { TableCell, TableRow, Typography } from "@material-ui/core";

class StatementDataRenderer extends Component {
  public iconColor: string = "rgb(0, 188, 212)";
  public noteField: null;

  public state = {
    balance: this.props.balance,
    memoPopupOpen: false,
    note: "",
    currentUnit: null,
    isChargeUpdatePopupOpen: false,
    selectedCharge: null,
    previousPropertyIds: [],
  };

  constructor(public props) {
    super(props);
  }

  public openChargeUpdatePopup = (charge) => {
    this.setState({
      isChargeUpdatePopupOpen: true,
      selectedCharge: charge,
    });
  };

  public closeChargeUpdatePopup = (initializePage) => {
    this.setState(
      {
        isChargeUpdatePopupOpen: false,
        selectedCharge: null,
      },
      () => {
        if (initializePage && typeof this.props.fetchStatement === "function") {
          this.props.fetchStatement.call(this);
        }
      }
    );
  };

  public renderEntityIcon = (entity: string): any => {
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          top: "4px",
          marginRight: "5px",
        }}
      >
        <div
          className={`icon icon-ic-${entity}`}
          style={{ color: this.iconColor }}
        ></div>
      </div>
    );
  };

  public renderChargeTemplate = (
    chargeTemplateId: number,
    _level: number
  ): any => {
    const template = this.props.app.chargeTemplates.find(
      (template) => template.id === chargeTemplateId
    );
    return (
      <TableRow
        hover
        key={`contract-${chargeTemplateId}-${uuidV4()}`}
        className={`no-border-bottom extra-small-height`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontSize: "11px",
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
        >
          {this.formatter.checkTranslationType(
            this.trans(template?.type?.label, {}, "", template?.type?.system),
            template?.type?.label,
            template?.type?.system
          )}
          :{" "}
          {this.formatter.formatNumber(
            template?.amount,
            CurrencyContainer.pickFromId(template?.currency.getCurrencyId())
          )}
          <span></span>
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderCharge = (
    charges: any[],
    _level: number,
    latePayment = false
  ): any[] => {
    const rows: any[] = [];

    charges
      .filter((charge) => !!charge)
      .sort((charge1, charge2) => {
        if (new Date(charge1?.createdAt) < new Date(charge2?.createdAt)) {
          return 1;
        }

        if (new Date(charge1?.createdAt) > new Date(charge2?.createdAt)) {
          return -1;
        }

        return 0;
      })
      .forEach((chargeObject) => {
        const charge: ChargeInterface = ChargeFactory.create(chargeObject);
        const infoAboutCharge: string = charge?.description
          ? `${charge?.description}${
              charge?.invoiceNumber ? ", " + charge?.invoiceNumber : ""
            }`
          : `${this.formatter.checkTranslationType(
              this.trans(charge?.type?.label, {}, "", charge?.type?.system),
              charge?.type?.label,
              charge?.type?.system
            )}${charge?.invoiceNumber ? ", " + charge?.invoiceNumber : ""}`;

        let vatPercentage: string = "";
        if (!isNaN(charge?.vatPercantage)) {
          vatPercentage = this.formatter.simpleFormatNumber(
            charge?.vatPercantage,
            false,
            false
          );
        }

        // Render the main charge row
        const mainChargeRow = (
          <TableRow
            hover
            key={`charge-${charge.id}-${uuidV4()}`}
            className={`clickable-entity no-border-bottom no-border-top extra-small-height ffff ${
              charge?.chargeTemplates?.length ? "row-with-template" : ""
            }`}
            onClick={() => this.openChargeUpdatePopup(charge)}
          >
            <TableCell
              style={{
                paddingLeft: `20px`,
                paddingRight: "5px",
                maxWidth: "300px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <div>
                {infoAboutCharge}
                {charge.chargeTemplates && charge.chargeTemplates.length > 1 && (
                  <div style={{marginLeft: "-20px"}}>
                    {charge.chargeTemplates.map((template) => (
                      this.renderChargeTemplate(template.id, _level + 1)
                    ))}
                  </div>
                )}
              </div>
            </TableCell>
            <TableCell
              style={{
                width: "14%",
                textAlign: "right",
                verticalAlign: "top",
                color: !latePayment
                  ? charge.getChargePaidAmountColorForStatement()
                  : "initial",
              }}
            >
              {charge?.isPaidDirectlyToOwner ? (
                this.trans("label-direct").toLowerCase()
              ) : charge?.isPayable ? (
                ""
              ) : charge?.amountPaidInCurrentPeriod === 0 &&
                charge?.paymentIds?.length > 0 ? (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    this.redirect(
                      `/app/payment/update/${
                        charge?.payments[charge?.payments.length - 1]?.id
                      }`
                    );
                  }}
                >
                  {this.formatter.monthShortYearFormatDate(
                    charge?.payments[charge?.payments.length - 1]
                      ?.firstDateOfStatementPeriod
                  )}
                </div>
              ) : (
                this.formatter.formatNumber(
                  charge.amountPaidInCurrentPeriod,
                  CurrencyContainer.pickFromId(
                    charge.currency.getCurrencyId()
                  )
                )
              )}
            </TableCell>
            {latePayment && (
              <TableCell style={{ width: "13%", textAlign: "right" }}>
                {this.formatter.formatNumber(
                  charge?.amountRemaining,
                  CurrencyContainer.pickFromId(
                    charge?.currency?.getCurrencyId()
                  )
                )}
              </TableCell>
            )}
            <TableCell
              style={{
                width: latePayment ? "28%" : "41%",
                textAlign: "right",
              }}
              colSpan={latePayment ? 1 : 2}
            >
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <div>
                  <span style={{ color: "#a0a0a0", marginRight: "5px" }}>
                    {Number(vatPercentage) > 0 &&
                    `(${
                      charge.vat > 0
                        ? this.formatter.formatNumber(
                            charge.vat,
                            CurrencyContainer.pickFromId(
                              charge.currency.getCurrencyId()
                            )
                          ) + " "
                        : ""
                    }${vatPercentage}% ${this.trans("label-vat")})`}
                  </span>
                  {charge?.isPayable && charge?.amount > 0
                    ? `${
                        this.props.isAgencyStatement ? "" : "-"
                      }${this.formatter.formatNumber(
                        charge?.amount,
                        CurrencyContainer.pickFromId(
                          charge?.currency?.getCurrencyId()
                        )
                      )}`
                    : this.formatter.formatNumber(
                        charge.amount,
                        CurrencyContainer.pickFromId(
                          charge.currency.getCurrencyId()
                        )
                      )}
                </div>
                <span
                  style={{
                    fontSize: "11px",
                    color: "#80808091",
                  }}
                >
                  {charge?.isPayable
                    ? this.trans("status-to-pay")
                    : this.trans("status-to-receive")}
                </span>
              </div>
            </TableCell>
          </TableRow>
        );

        rows.push(mainChargeRow);

        //rows.push(this.renderEmptyRow(true, true));
      });

    return rows;
  };

public renderAlreadyPaidCharge = (
  charges: any[],
  _level: number,
  latePayment = false
): any[] => {
  const rows: any[] = [];

  charges
      .filter((charge) => !!charge)
      .sort((charge1, charge2) => {
          if (new Date(charge1?.createdAt) < new Date(charge2?.createdAt)) {
              return 1;
          }

          if (new Date(charge1?.createdAt) > new Date(charge2?.createdAt)) {
              return -1;
          }

          return 0;
      })
      .forEach((chargeObject) => {
          const charge: ChargeInterface = ChargeFactory.create(chargeObject);
          const infoAboutCharge: string = charge?.description
              ? `${charge?.description}${
                  charge?.invoiceNumber ? ", " + charge?.invoiceNumber : ""
              }`
              : `${this.formatter.checkTranslationType(
                  this.trans(charge?.type?.label, {}, "", charge?.type?.system),
                  charge?.type?.label,
                  charge?.type?.system
              )}${charge?.invoiceNumber ? ", " + charge?.invoiceNumber : ""}`;

          let vatPercentage: string = "";
          if (!isNaN(charge?.vatPercantage)) {
              vatPercentage = this.formatter.simpleFormatNumber(
                  charge?.vatPercantage,
                  false,
                  false
              );
          }

          // Render the main charge row
          const mainChargeRow = (
              <TableRow
                  hover
                  key={`charge-${charge.id}-${uuidV4()}`}
                  className={`clickable-entity no-border-bottom small-height ffff ${
                      charge?.chargeTemplates?.length ? "row-with-template" : ""
                  }`}
                  onClick={() => this.openChargeUpdatePopup(charge)}
              >
                  <TableCell
                      style={{
                          paddingLeft: `20px`,
                          paddingRight: "5px",
                          maxWidth: "300px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                      }}
                  >
                      {infoAboutCharge}
                  </TableCell>
                  <TableCell
                      style={{
                          width: "14%",
                          textAlign: "right",
                          verticalAlign: "top",
                          color: !latePayment
                              ? charge.getChargePaidAmountColorForStatement()
                              : "initial",
                      }}
                  >
                      {charge?.isPaidDirectlyToOwner ? (
                          this.trans("label-direct").toLowerCase()
                      ) : charge?.isPayable ? (
                          ""
                      ) : charge?.amountPaidInCurrentPeriod === 0 &&
                        charge?.paymentIds?.length > 0 ? (
                          <div
                              onClick={(e) => {
                                  e.stopPropagation();
                                  this.redirect(
                                      `/app/payment/update/${
                                          charge?.payments[charge?.payments.length - 1]?.id
                                      }`
                                  );
                              }}
                          >
                              {this.formatter.monthShortYearFormatDate(
                                  charge?.payments[charge?.payments.length - 1]
                                      ?.firstDateOfStatementPeriod
                              )}
                          </div>
                      ) : (
                          this.formatter.formatNumber(
                              charge.amountPaidInCurrentPeriod,
                              CurrencyContainer.pickFromId(
                                  charge.currency.getCurrencyId()
                              )
                          )
                      )}
                  </TableCell>
                  {latePayment && (
                      <TableCell style={{ width: "13%", textAlign: "right" }}>
                          {this.formatter.formatNumber(
                              charge?.amountRemaining,
                              CurrencyContainer.pickFromId(
                                  charge?.currency?.getCurrencyId()
                              )
                          )}
                      </TableCell>
                  )}
                  <TableCell
                      style={{
                          width: latePayment ? "28%" : "41%",
                          textAlign: "right",
                      }}
                      colSpan={latePayment ? 1 : 2}
                  >
                      <div style={{ display: "inline-flex", flexDirection: "column" }}>
                          <div>
                              <span style={{ color: "#a0a0a0", marginRight: "5px" }}>
                                  {Number(vatPercentage) > 0 &&
                                  `(${
                                      charge.vat > 0
                                          ? this.formatter.formatNumber(
                                              charge.vat,
                                              CurrencyContainer.pickFromId(
                                                  charge.currency.getCurrencyId()
                                              )
                                          ) + " "
                                          : ""
                                  }${vatPercentage}% ${this.trans("label-vat")})`}
                              </span>
                              {charge?.isPayable && charge?.amount > 0

                                  ? `${
                                      this.props.isAgencyStatement ? "-" : ""
                                  }${this.formatter.formatNumber(
                                      charge?.amount,
                                      CurrencyContainer.pickFromId(
                                          charge?.currency?.getCurrencyId()
                                      )
                                  )}`
                                  : this.formatter.formatNumber(
                                      charge.amount,
                                      CurrencyContainer.pickFromId(
                                          charge.currency.getCurrencyId()
                                      )
                                  )}
                          </div>
                          <span
                              style={{
                                  fontSize: "11px",
                                  color: "#80808091",
                              }}
                          >
                              {charge?.isPayable
                                  ? this.trans("status-to-pay")
                                  : this.trans("status-to-receive")}
                          </span>
                      </div>
                  </TableCell>
              </TableRow>
          );

          rows.push(mainChargeRow);

          // Render subcharges
          if (charge.chargeTemplates && charge.chargeTemplates.length > 1) {
              charge.chargeTemplates.forEach((template) => {
                  const subChargeRow = this.renderChargeTemplate(template.id, _level + 1);
                  rows.push(subChargeRow);
              });
          }
      });

  return rows;
};

  public renderContractRow = (
    _level: number,
    contract: any,
    unit: any
  ): any => {
    const unitId: number = unit?.id;
    const unitEntity: UnitInterface = this.props.units.byId[unitId];
    const contractId: number = contract.id;
    const contractEntity: ContractInterface = this.props.app.contracts.find(
      (contract) => contract.id === contractId
    );
    const tenant: PersonInterface = contractEntity && contractEntity.person;
    const propertyChargesLength = unit?.propertyCharges?.length > 0;
    return (
      <TableRow
        hover
        key={`contract-${contract.id}-${uuidV4()}`}
        className={`clickable-entity no-border-bottom no-border-top extra-small-height`}
        onClick={() => {
          this.redirect(`/app/contract/update/${contract.id}`);
        }}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            border: 0,
          }}
        >
          {/* {this.renderEntityIcon("contract")} */}
          {propertyChargesLength && (
            <p
              style={{
                lineHeight: "17px",
                margin: "0",
                fontWeight: 600,
                color: " #000",
                fontSize: "16px",
                paddingBottom: "10px",
                paddingTop: "15px",
              }}
            >{`${this.formatter.checkTranslationType(
              this.trans(unitEntity?.type?.label),
              unitEntity?.type?.label
            )}${unitEntity?.unitNumber ? ` ${unitEntity?.unitNumber}` : ""}${
              unitEntity?.property?.complexName
                ? ` (${unitEntity?.property?.complexName})`
                : ""
            } `}</p>
          )}
          <p
            style={{
              margin: "0",
              lineHeight: "17px",
              fontWeight: 400,
              fontSize: "16px",
              // paddingBottom: "10px",
            }}
          >{`${tenant ? `${tenant?.firstName} ${tenant?.lastName}` : ""}`}</p>
        </TableCell>
        <TableCell style={{ width: "14%", border: 0 }}></TableCell>
      </TableRow>
    );
  };

  public renderUnitRow = (_level: number, unit: any, property: any): any => {
    const propertyId: number = property?.id;
    const selectedProperty: PropertyInterface =
      this.props.properties.byId[propertyId];
    const propertyFormattedAddress: string = !!selectedProperty
      ? selectedProperty.address && selectedProperty.address.formattedAddress
      : "";
    const unitId: number = unit.id;
    const unitEntity: UnitInterface = this.props.units.byId[unitId];
    const propertyChargesLength = unit?.propertyCharges?.length > 0;
    console.log(propertyFormattedAddress);
   

    return (
      <div >
        <TableRow
          hover
          key={`unit-${unit.id}-${uuidV4()}`}
          className={`clickable-entity no-border-bottom has-border-top small-height bottom-padding`}
          onClick={() => {
            this.redirect(`/app/unit/update/${unit.id}`);
          }}
        >
          {!propertyChargesLength && (
            <TableCell
              colSpan={3}
              style={{
                width: "86%",
                // paddingLeft: `${20 * level}px`,
                paddingLeft: `20px`,
                paddingRight: "5px",
                fontWeight: "bold",
                position: "relative",
                paddingBottom: "0px",
                paddingTop: "20px !important",
                border: 0,
              }}
            >
              {/* {this.renderEntityIcon("unit")} */}
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "#000000",
                  lineHeight: "20px",
                }}
              >
                {/* {propertyFormattedAddress} */}
              </span>

              <div
                style={{
                  lineHeight: "17px",
                  fontWeight: 600,
                  color: " #000",
                  fontSize: "16px",
                }}
              >{`${this.formatter.checkTranslationType(
                this.trans(unitEntity?.type?.label),
                unitEntity?.type?.label
              )}${unitEntity?.unitNumber ? ` ${unitEntity?.unitNumber}` : ""}${
                unitEntity?.property?.complexName
                  ? ` (${unitEntity?.property?.complexName})`
                  : ""
              } `}</div>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  this.openMemoPopup(unitEntity);
                }}
                className={`icon ${
                  unitEntity?.hasMemos
                    ? "icon-ic-bookmark blue-onhover"
                    : // : "icon-ic-memo"
                      " "
                }`}
                style={{
                  position: "absolute",
                  top: "4px",
                  marginLeft: "3px",
                }}
              ></span>
            </TableCell>
          )}
          <TableCell style={{ width: "14%", border: 0 }}></TableCell>
        </TableRow>
      </div>
    );
  };

  public hasDuplicateRepeatPeriodIds = (
    chargeTemplates: any[],
    repeatPeriodId: number,
    indexOfCurrentElement: number
  ) => {
    return chargeTemplates.some((otherElement, index) => {
      return (
        index !== indexOfCurrentElement &&
        otherElement.repeatPeriodId === repeatPeriodId
      );
    });
  };

public renderUnitBalance = (
  unit: any,
  level: number,
  latePayment = false
): any[] => {
  const renderedRows: any[] = [];
  const unitReceivables: any[] = [];
  const unitPayables: any[] = [];
  const propertyReceivables: any[] = [];
  const propertyPayables: any[] = [];

  unit?.propertyCharges?.forEach((chargeObject) => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);
    charge?.isReceivable
      ? propertyReceivables.push(chargeObject)
      : propertyPayables.push(chargeObject);
  });
  const propertyReceivablesRows: any[] = this.renderCharge(
    propertyReceivables || [],
    level + 1,
    latePayment
  );
  propertyReceivablesRows.forEach((row) => renderedRows.push(row));
  const propertyPayablesRows: any[] = this.renderCharge(
    propertyPayables || [],
    level + 1,
    latePayment
  );
  propertyPayablesRows.forEach((row) => renderedRows.push(row));

  unit?.charges?.forEach((chargeObject) => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);
    charge?.isReceivable
      ? unitReceivables.push(chargeObject)
      : unitPayables.push(chargeObject);
  });
  const unitReceivablesRows: any[] = this.renderCharge(
    unitReceivables || [],
    level + 1,
    latePayment
  );
  unitReceivablesRows.forEach((row) => renderedRows.push(row));
  const unitPayablesRows: any[] = this.renderCharge(
    unitPayables || [],
    level + 1,
    latePayment
  );
  unitPayablesRows.forEach((row) => renderedRows.push(row));

  [...unitReceivablesRows, unitPayablesRows]
    .filter((charge) => charge.isCollective)
    .forEach((charge) => {
      if (this.props.statementData?.firstDate >= "2023-10-01") {
        const chargeTemplates = charge?.chargeTemplates;
        // Check if there are more than one template
        if (chargeTemplates && chargeTemplates.length > 1) {
            chargeTemplates
                .sort((t1, t2) => t1.amount - t2.amount)
                .forEach((template) => {
                    const row: any[] = this.renderChargeTemplate(template?.id, level + 1);
                    const index = renderedRows.findIndex((e) => e?.key?.includes(String(charge?.id)));
                    if (index !== -1) {
                        renderedRows.splice(index + 1, 0, row);
                    }
                });
        }
      }
    
    });

  !!unit.contracts &&
    unit.contracts
      .filter((contract) => !!contract)
      .sort(this.contractComparer)
      .forEach((contract) => {
        if (!!contract.charges && contract.charges.length === 0) {
          return;
        }

        const contractsReceivables: any[] = [];
        const contractsPayables: any[] = [];
        const contractRow: any = this.renderContractRow(
          level,
          contract,
          unit
        );

        contract?.charges?.forEach((chargeObject) => {
          const charge: ChargeInterface = ChargeFactory.create(chargeObject);
          charge?.isReceivable
            ? contractsReceivables.push(chargeObject)
            : contractsPayables.push(chargeObject);
        });

        renderedRows.push(contractRow);
     
        const contractsReceivablesRows: any[] = this.renderCharge(
          contractsReceivables || [],
          level + 1,
          latePayment
        );
        contractsReceivablesRows.forEach((row) => {
          renderedRows.push(row);
        });

        const contractsPayablesRows: any[] = this.renderCharge(
          contractsPayables || [],
          level + 1,
          latePayment
        );
        contractsPayablesRows.forEach((row) => renderedRows.push(row));

        [...contractsReceivables, contractsPayables]
          .filter((charge) => charge.isCollective)
          .forEach((charge) => {
            if (this.props.statementData?.firstDate >= "2023-10-01") {
              const chargeTemplates = charge?.chargeTemplates;
              if (chargeTemplates && chargeTemplates.length > 1) {
              chargeTemplates
                ?.sort((t1, t2) => t1.amount - t2.amount)
                .forEach((template, i) => {
                  const hasDuplicateRepeatPeriodIds =
                    this.hasDuplicateRepeatPeriodIds(
                      chargeTemplates,
                      template.repeatPeriodId,
                      i
                    );
                  if (
                    chargeTemplates.length > 1 &&
                    hasDuplicateRepeatPeriodIds
                  ) {
                    const row: any[] = this.renderChargeTemplate(
                      template?.id,
                      level + 1
                    );
                    const index = renderedRows.findIndex((e) =>
                      e?.key?.includes(String(charge?.id))
                    );
                    if (index !== -1) {
                      renderedRows.splice(index + 1, 0, row);
                    }
                  }
                });
              }
            }
          });
          renderedRows.push(this.renderEmptyRow(false, true));
      });

  return renderedRows;
};

  public renderPropertyRow = (_level: number, property: any): any => {
    const propertyId: number = property.id;
    const selectedProperty: PropertyInterface =
      this.props.properties.byId[propertyId];
    const propertyFormattedAddress: string = !!selectedProperty
      ? selectedProperty.address && selectedProperty.address.formattedAddress
      : "";

    return (
      <TableRow
        style={{ height: "38px" }}
        hover
        key={`property-${property.id}-${uuidV4()}`}
        className={`clickable-entity no-border-bottom has-border-top`}
        onClick={() => this.redirect(`/app/property/update/${property.id}`)}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            fontSize: "18px",
            verticalAlign: "middle !important",
            border: 0,
          }}
        >
          {/* {this.renderEntityIcon("property")} */}

          <Typography
            style={{ fontWeight: "bold", fontSize: "18px" }}
          >{`${propertyFormattedAddress}`}</Typography>
        </TableCell>
        <TableCell style={{ width: "14%", border: 0 }}></TableCell>
      </TableRow>
    );
  };

  public renderPropertyBalance = (
    property: any,
    level: number,
    latePayment = false
  ): any[] => {
    const renderedRows: any[] = [];

    !!property.units &&
      property.units
        .filter((unit) => !!unit)
        .sort(this.unitComparer)
        .forEach((unit) => {
          if (
            !!unit.charges &&
            unit.charges.length === 0 &&
            ((!!unit.contracts && unit.contracts.length === 0) ||
              (!!unit.contracts &&
                unit.contracts.every((contract) => {
                  if (!contract) {
                    return true;
                  }

                  return !!contract.charges && contract.charges.length === 0;
                })))
          ) {
            return;
          }

          if (property?.units?.[0]) {
            property.units[0].propertyCharges = [...(property?.charges || [])];
          }

          const unitRow: any = this.renderUnitRow(level + 1, unit, property);
          // if (
          //   property.units.length > 0  && !this.state.previousPropertyIds.includes(property.id) 
          // ) {
          //   const propertyRow: any = this.renderPropertyRow(level, property);
          //   renderedRows.push(propertyRow);
          //   this.state.previousPropertyIds.push(property.id);
          // } 


          const renderUnitBalanceArray = this.renderUnitBalance(
            unit,
            level + 1,
            latePayment
          );
          renderedRows.push(unitRow);
          renderUnitBalanceArray.forEach((row) => renderedRows.push(row));
         
        });

    return renderedRows;
  };

  public renderOwnerRow = (_level: number, ownerId: number): any => {
    const companyId: number = ownerId;
    const companyEntity: CompanyInterface = this.props.app.companies.find(
      (company: CompanyInterface) => company.id === companyId
    );

    return (
      <TableRow
        hover
        key={`owner-row-${uuidV4()}`}
        className={`clickable-entity`}
        onClick={() => {
          this.redirect(`/app/owner/update/${companyId}`);
        }}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
          }}
        >
          {/* {this.renderEntityIcon("company")} */}
          {`${
            companyEntity && companyEntity.displayName
              ? companyEntity.displayName
              : ""
          }${
            !!companyEntity &&
            !!companyEntity.address &&
            !!companyEntity.address.formattedAddress
              ? `, ${companyEntity?.address?.formattedAddress}`
              : ""
          }`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderOwnerBalance = (owner: any, level: number): any[] => {
    const renderedRows: any[] = this.renderCharge(owner.charges || [], level);
    !!owner.properties &&
      owner.properties
        .filter((property) => !!property)
        .sort(this.propertyComparer)
        .forEach((property) => {
          if (
            !!property.charges &&
            property.charges.length === 0 &&
            property.units.every((unit) => {
              if (!unit) {
                return true;
              }

              return (
                !!unit.charges &&
                unit.charges.length === 0 &&
                (unit.contracts.length === 0 ||
                  unit.contracts.every((contract) => {
                    if (!contract) {
                      return true;
                    }

                    return !!contract.charges && contract.charges.length === 0;
                  }))
              );
            })
          ) {
            return;
          }

          // if (property.units.length >=0) {
          //   const propertyRow: any = this.renderPropertyRow(
          //     level + 1,
          //     property
          //   );
          //   renderedRows.push(propertyRow);
          // }

          const renderPropertyBalanceArray = this.renderPropertyBalance(
            property,
            level + 2
          );
          renderPropertyBalanceArray.forEach((row) => renderedRows.push(row));
    
        });

    return renderedRows;
  };

  public renderTitleRow = (title: string): any => {
    return (
      <TableRow key={`title-${uuidV4()}`} className={`no-border-bottom`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {`${title}`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderInvoiceDateRow = (_level: number): any => {
    return (
      <TableRow
        key={`title-${uuidV4()}`}
        className={`small-height no-border-bottom`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
          }}
        >
          {`${this.trans(
            "section/charge-field/invoiceperiod-label"
          )}: ${Time.useFormat(
            this.props.statementData?.firstDate,
            "MMMM YYYY"
          )}`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderInvoiceNumberRow = (
    _level: number,
    invoiceNumber: string
  ): any => {
    return (
      <TableRow
        key={`title-${uuidV4()}`}
        className={`small-height no-border-bottom`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
          }}
        >
          {`${this.trans(
            "section/charge-field/invoicenumber-label"
          )}: ${invoiceNumber}`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderInvoicePeriodRow = (_level: number): any => {
    return (
      <TableRow
        key={`title-${uuidV4()}`}
        className={`small-height no-border-bottom`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
          }}
        >
          {`${this.trans(
            "section/charge-field/invoicedate-label"
          )}: ${this.formatter.formatDate(
            this.props.statementData?.data?.payoutSection?.actualPayoutCharge
              ?.invoiceDate
              ? this.props.statementData?.data?.payoutSection
                  ?.actualPayoutCharge?.invoiceDate
              : new Date()
          )}`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderSummaryRow = (_level: number): any => {
    return (
      <TableRow key={`summary-${uuidV4()}`} className={`small-height`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontSize: "15px",
            fontStyle: "italic",
          }}
        >
          {`${this.trans("summary")} ${Time.useFormat(
            this.props.statementData?.firstDate,
            "MMMM YYYY"
          )}`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  // JB
  // Details section header
  public renderDetailsRow = (_level: number): any => {
    return (
      <>
        <TableRow
          hover
          key={`details-${uuidV4()}`}
          className="bigger-row clickable-entity"
          onClick={() =>
            this.redirect(
              `/app/owner/update/${this.props.statementData?.ownerId}`
            )
          }
        >
          <TableCell
            className="bigger-row"
            style={{
              lineHeight: "24px",
              // paddingLeft: `${20 * level}px`,
              paddingLeft: `20px`,
              width: "45%",
              fontSize: "20px",
              fontWeight: "bold",
              border: 0,
            }}
          >
            {`${this.trans("details-for")}`}
          </TableCell>
          <TableCell
            style={{ width: "14%", textAlign: "right", border: 0 }}
            className="align-right"
          >
            {this.trans("title-paid")}
          </TableCell>
          <TableCell
            style={{ width: "13%", textAlign: "right", border: 0 }}
            className="align-right"
          ></TableCell>
          <TableCell
            colSpan={2}
            style={{ width: "28%", textAlign: "right", border: 0 }}
            className="align-right"
          >
            {this.trans("label-amount")}
          </TableCell>
        </TableRow>
      </>
    );
  };

  public renderToBeReceivedRow = (_level: number): any => {
    return (
      <TableRow key={`to-be-received-${uuidV4()}`} className="bigger-row">
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontWeight: "bold",
          }}
        >
          {this.trans("to-be-received", {
            ownername: this.props.companyEntity?.displayName,
          })}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderEmptyRow = (
    small: boolean = false,
    noBorderBottom: boolean = false
  ): any => {
    return (
      <TableRow
        key={`empty-${uuidV4()}`}
        className={`${small ? "empty-row-small" : "empty-row"} ${
          noBorderBottom ? "no-border-bottom" : ""
        }`}
      >
        <TableCell colSpan={4}></TableCell>
      </TableRow>
    );
  };

  public renderStatementCompanyRow = (_level: number): any => {
    const companyId: number = this.props && this.props.statementData.ownerId;
    const companyEntity: CompanyInterface = this.props.app.companies.find(
      (company: CompanyInterface) => company.id === companyId
    );
    return (
      <TableRow
        hover
        key={`statement-company-row-${uuidV4()}`}
        className={`clickable-entity`}
        onClick={() => {
          if (!this.props.isAgencyStatement) {
            this.redirect(`/app/owner/update/${companyId}`);
          }
        }}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
          }}
        >
          {/* {this.renderEntityIcon("company")} */}
          {!this.props.isAgencyStatement &&
            `${
              companyEntity && companyEntity.displayName
                ? companyEntity.displayName
                : ""
            }${
              !!companyEntity &&
              !!companyEntity.address &&
              !!companyEntity.address.formattedAddress
                ? `, ${companyEntity?.address?.formattedAddress}`
                : ""
            }`}
          {this.props.isAgencyStatement && this.getAgency()?.name}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderResultRow = (_level: number): any => {
    return (
      <TableRow
        key={`result-to-be-paid-received-by-owner-${uuidV4()}`}
        className="result-row no-border-bottom small-height"
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            fontSize: "17px",
          }}
        >
          {`${this.trans("result")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: "17px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            this.props.statementData?.data?.payoutSection?.result,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderAgencyResultRow = (_level: number): any => {
    return (
      <TableRow
        key={`result-to-be-paid-received-by-owner-${uuidV4()}`}
        className="result-row no-border-bottom small-height"
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            fontSize: "17px",
          }}
        >
          {`${this.trans("result")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: "17px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            this.props.statementData?.data?.payoutSection?.result,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalToPayByOwnerRow = (_level: number): any => {
    const totalAmountOfAgencyService =
      this.props.statementData?.data?.totalAmountOfAgencyService;
    const totalAmountOfAgencyServiceToShow = totalAmountOfAgencyService * -1;
    return (
      <TableRow
        key={"total-agency-services"}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#000000",
          }}
        >
          {totalAmountOfAgencyService < 0
            ? `${this.trans("total-to-pay-by-owner")} ${
                this.props.companyEntity?.displayName
              }`
            : `${this.trans("to-be-received", {
                ownername: this.props.companyEntity?.displayName,
              })}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            fontSize: "17px",
            fontWeight: "bold",
            color: "#000000",
          }}
        >
          {/* todo fix hardcoded currency */}
          {`${this.formatter.formatNumber(
            !!totalAmountOfAgencyService ? totalAmountOfAgencyServiceToShow : 0,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalAmountsAgencyServiceExclVatRow = (_level: number): any => {
    return (
      <TableRow
        key={"total-agency-services-exclusive-vat"}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            color: "#000000",
            fontSize: "15px",
          }}
        >
          {`${this.trans("total-agency-services")} ${this.getAgency()?.name}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            color: "#000000",
            fontSize: "15px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            !!this.props.statementData?.data?.totalAmountOfAgencyServiceExclVat
              ? this.props.statementData.data.totalAmountOfAgencyServiceExclVat
              : 0,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalAmountsCreditInvoiceExclVatRow = (_level: number): any => {
    return (
      <TableRow
        key={"total-agency-services-exclusive-vat"}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            color: "#676767",
            fontSize: "15px",
          }}
        >
          {`${this.trans("amount-to-credit")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            color: "#a0a0a0",
            fontSize: "15px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            !!this.props.statementData?.data?.totalAmountOfAgencyServiceExclVat
              ? this.props.statementData.data.totalAmountOfAgencyServiceExclVat
              : 0,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderVatPercentageRow = (
    _level: number,
    vatPercentage: number,
    vatAmount: number
  ): any => {
    return (
      <TableRow
        key={`lavel-vat-${vatPercentage}`}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            color: "#000000",
            fontSize: "15px",
          }}
        >
          {`${this.trans(
            "label-vat",
            {},
            this.props.language
          )} ${vatPercentage}%`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            color: "#000000",
            fontSize: "15px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(vatAmount ? vatAmount : 0, new EUR())}
        </TableCell>
      </TableRow>
    );
  };

  public renderLeftToPayRow = (_level: number): any => {
    const isPayable =
      this.props.statementData?.data?.payoutSection?.actualPayoutCharge
        ?.chargeClassId == ChargeClassContainer.pickIdFromLabel("Payable");
    const leftToPay = this.props.statementData?.data?.payoutSection?.leftToPay;
    let lineText = "";

    if (leftToPay < 0) {
      lineText = this.trans("to-be-paid", {
        ownername: this.props.companyEntity?.displayName,
      });
    } else if (leftToPay > 0) {
      lineText = this.trans("to-be-received", {
        ownername: this.props.companyEntity?.displayName,
      });
    } else {
      lineText = isPayable
        ? this.trans("to-be-received", {
            ownername: this.props.companyEntity?.displayName,
          })
        : this.trans("to-be-paid", {
            ownername: this.props.companyEntity?.displayName,
          });
    }

    return (
      <TableRow
        key={`left-to-paid-received-by-owner-${uuidV4()}`}
        className="left-to-pay-row no-border-bottom small-height"
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            fontSize: "15px",
          }}
        >
          {lineText}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: "19px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {`${this.formatter.formatNumber(leftToPay, new EUR())}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderPreviousPayoutRow = (
    chargeObject,
    index,
    _level: number
  ): any => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);
    const descriptionByTypeAndDate = `${this.formatter.checkTranslationType(
      this.trans(charge?.type?.label, {}, "", charge?.type?.system),
      charge?.type?.label,
      charge?.type?.system
    )} (${index + 1}) ${this.formatter.monthFullFormatDate(
      charge?.firstDate
    )}`.replace(/\s{2,}/g, " ");

    return (
      <TableRow
        key={`previous-payout-${charge?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height`}
        onClick={() => {
          return this.redirect(`/app/charge/update/${charge?.id}`);
        }}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {charge &&
              `${descriptionByTypeAndDate} (${this.formatter.formatDate(
                charge?.invoiceDate
              )}) - ${
                charge?.isPayable
                  ? this.trans("to-be-received-small-first-letter", {
                      ownername: this.props.companyEntity?.displayName,
                    })
                  : this.trans("to-be-paid-small-first-letter", {
                      ownername: this.props.companyEntity?.displayName,
                    })
              }`}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "5px",
              }}
            >
              {!!charge?.isLocked && (
                <div className="list-label creation-type-label">
                  {this.trans("owner-statement-closed")}
                </div>
              )}
            </div>
          </div>
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {`${
            !charge?.isPayable ? "-" : ""
          }${this.formatter.formatNumberWithoutMinus(
            charge?.amount,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderActualPayoutRow = (chargeObject, _level: number): any => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);
    const descriptionByTypeAndDate = `${this.formatter.checkTranslationType(
      this.trans(charge?.type?.label, {}, "", charge?.type?.system),
      charge?.type?.label,
      charge?.type?.system
    )}${
      (
        this.props.statementData?.data?.payoutSection?.previousPayoutCharges ||
        []
      ).length === 0
        ? ""
        : ` (${
            (
              this.props.statementData?.data?.payoutSection
                ?.previousPayoutCharges || []
            ).length + 1
          })`
    } ${this.formatter.monthFullFormatDate(charge?.firstDate)}`.replace(
      /\s{2,}/g,
      " "
    );
    const settlementCharges =
      this.props.statementData?.data?.payoutSection?.settlementCharges || [];
    const shouldShowPaySections =
      (charge?.amountPaid > 0 || settlementCharges?.length > 0) &&
      charge?.amountPaid !== charge?.amount;

    return (
      <TableRow
        key={`result-to-be-the-payout-${charge?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height ${
          !shouldShowPaySections ? "left-to-pay-row" : ""
        }`}
        onClick={() => {
          return this.redirect(`/app/charge/update/${charge?.id}`);
        }}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: !shouldShowPaySections ? "bold" : "normal",
            fontSize: !shouldShowPaySections ? "15px" : "14px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: !shouldShowPaySections ? "bold" : "normal",
              fontSize: !shouldShowPaySections ? "15px" : "14px",
            }}
          >
            {charge &&
              `${descriptionByTypeAndDate} - ${
                charge?.isPayable
                  ? this.trans("to-be-received-small-first-letter", {
                      ownername: this.props.companyEntity?.displayName,
                    })
                  : this.trans("to-be-paid-small-first-letter", {
                      ownername: this.props.companyEntity?.displayName,
                    })
              }`}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "5px",
                fontWeight: "normal",
              }}
            >
              {!!charge?.isLocked && (
                <div className="list-label creation-type-label">
                  {this.trans("owner-statement-closed")}
                </div>
              )}
            </div>
          </div>
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            fontWeight: !shouldShowPaySections ? "bold" : "normal",
            fontSize: !shouldShowPaySections ? "19px" : "17px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {`${
            !charge?.isPayable ? "-" : ""
          }${this.formatter.formatNumberWithoutMinus(
            charge?.amount,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderSettlementChargeRow = (chargeObject, _level: number): any => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);

    const isPayable =
      charge?.chargeClass?.id ==
      ChargeClassContainer.pickIdFromLabel("Payable");
    const chargeDescription = charge?.description
      ? charge?.description
      : this.trans("textfield-no-description");

    return (
      <TableRow
        key={`settlement-charge-${charge?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height`}
        onClick={() => {
          return this.redirect(`/app/charge/update/${charge?.id}`);
        }}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {charge &&
            `${chargeDescription} - ${
              isPayable
                ? this.trans("to-be-received-small-first-letter", {
                    ownername: this.props.companyEntity?.displayName,
                  })
                : this.trans("to-be-paid-small-first-letter", {
                    ownername: this.props.companyEntity?.displayName,
                  })
            }`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {`${!isPayable ? "-" : ""}${this.formatter.formatNumberWithoutMinus(
            charge?.amountRemaining,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderSavingsChargeRow = (chargeObject, _level: number): any => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);
    const isPayable =
      charge?.chargeClass?.id ==
      ChargeClassContainer.pickIdFromLabel("Payable");
    const chargeDescription = `${this.formatter.checkTranslationType(
          this.trans(charge?.type?.label, {}, "", charge?.type?.system),
          charge?.type?.label,
          charge?.type?.system
        )}`;

    return (
      <TableRow
        key={`settlement-charge-${charge?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height`}
        onClick={() => {
          return this.redirect(`/app/charge/update/${charge?.id}`);
        }}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >


          {charge &&
            `${chargeDescription}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {`${isPayable ? "-" : ""}${this.formatter.formatNumberWithoutMinus(
            charge?.amount,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderSettledChargeRow = (chargeObject, _level: number): any => {
    const charge: ChargeInterface = ChargeFactory.create(chargeObject);
    const isPayable =
      charge?.chargeClass?.id ==
      ChargeClassContainer.pickIdFromLabel("Payable");

    return (
      <TableRow
        key={`settlement-charge-${charge?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height`}
        onClick={() => {
          return this.redirect(`/app/charge/update/${charge?.id}`);
        }}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {charge &&
            `${charge?.description}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {`${isPayable ? "-" : ""}${this.formatter.formatNumberWithoutMinus(
            charge?.amount,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };
  public renderDepositeAndWithdrawalPaymentRow = (paymentObject, isDeposite, _level: number, property = null): any => {
    const payment: PaymentInterface = PaymentFactory.create(paymentObject);
    const chargeDescription = `${this.trans(payment?.paymentType?.label, {}, "")}`;

    const properties = property?.displayName ? `${payment.description} - ${property.displayName}`: "";

    const chargeDescriptionTwo = payment?.description ? properties : chargeDescription;

    return (
      <TableRow
        key={`settlement-charge-${payment?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height`}
        onClick={() => {
          return this.redirect(`/app/payment/update/${payment?.id}`);
        }}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {payment &&
            chargeDescriptionTwo}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {`${isDeposite ? "" : "-"}${this.formatter.formatNumberWithoutMinus(
            payment?.amount,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderSettledPaymentRow = (payment, _level: number): any => {
    return (
      <TableRow
        key={`settled-payment-${payment?.id}-${uuidV4()}`}
        className={`clickable-entity clickable-entity-payout no-border-bottom small-height`}
        onClick={() => this.redirect(`/app/payment/update/${payment?.id}`)}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {`${Time.useFormat(payment?.dateOfThePayment, "DD MMMM YYYY")}${
            payment?.description ? " - " + payment.description : ""
          }`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumberWithoutMinus(
            payment?.amountDetails?.[
              this.props.statementData?.data?.payoutSection?.actualPayoutCharge
                ?.id
            ],
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderPayoutSectionTitleRow = (title: string, _level: number): any => {
    return (
      <TableRow
        key={`payout-section-title-${title}-${uuidV4()}`}
        className={`small-height`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontStyle: "italic",
            fontSize: "15px",
          }}
        >
          {title}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderOwnerPayoutSectionTitleRow = (title: string, _level: number, settlementCharges: any): any => {
    const chargesOwner = [];
    settlementCharges.forEach((charge) => {
      if (charge?.ownerId !== this.props.statementData?.ownerId) {
        chargesOwner.push(false);
      } else {
        chargesOwner.push(true);
      }
    })
    if (chargesOwner.every(value => value === false)) {
      return;
    }
    return (
      <TableRow
        key={`payout-section-title-${title}-${uuidV4()}`}
        className={`small-height`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontStyle: "italic",
            fontSize: "15px",
          }}
        >
          {title}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderAlreadySettledPayoutRow = (charge, _level: number): any => {
    return (
      <TableRow key={`already-settled-${charge?.id}-${uuidV4()}`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {this.trans("already-settled")}
        </TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumberWithoutMinus(
            charge?.amountPaid,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderAlreadySettledPayoutCorrectionRow = (
    charge,
    _level: number
  ): any => {
    const correctionLine: string = ` (${this.trans(
      "correction"
    )} ${this.formatter.formatDate(new Date(charge.createdAt))})`;

    return (
      <TableRow key={`already-settled-${charge?.id}-${uuidV4()}`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {`${this.trans("already-settled")} ${correctionLine}`}
        </TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumberWithoutMinus(
            charge?.amountPaid,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalExpensesRow = (_level: number): any => {
    return (
      <TableRow
        key={`total-expences-${uuidV4()}`}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#676767",
          }}
        >
          {`${this.trans("total-expences")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {`${
            this.props.statementData?.totalExpenses ? "-" : ""
          }${this.formatter.formatNumber(
            this.props.statementData?.totalExpenses,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalIncomeRow = (_level: number): any => {
    return (
      <TableRow
        key={`total-sum-payments-for-month-${uuidV4()}`}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#676767",
          }}
        >
          {`${this.trans("total-sum-payments-for-month")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            !!this.props.statementData.data &&
              !!this.props.statementData.data.totalOfPayments
              ? this.props.statementData.data.totalOfPayments
              : 0,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalAgencyIncomeRow = (_level: number): any => {
    return (
      <TableRow
        key={`total-sum-payments-for-month-${uuidV4()}`}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#676767",
          }}
        >
          {`${this.trans("total-sum-payments-for-month")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {/* todo fix hardcoded currency */}
          {`${this.formatter.formatNumber(
            this.props.statementData?.data?.payoutSection?.depositedAmount,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalAgencyExpensesRow = (_level: number): any => {
    return (
      <TableRow
        key={`total-expences-${uuidV4()}`}
        className={"no-border-bottom small-height"}
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#676767",
          }}
        >
          {`${this.trans("total-expences")}`}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{ width: "28%", textAlign: "right", fontSize: "17px" }}
        >
          {`${
            !!this.props.statementData.data &&
            !!this.props.statementData.data.totalOfPayments
              ? "-"
              : ""
          }${this.formatter.formatNumber(
            !!this.props.statementData?.data?.payoutSection?.withdrawnAmount &&
              !!this.props.statementData?.data?.payoutSection?.withdrawnAmount
              ? this.props.statementData?.data?.payoutSection?.withdrawnAmount
              : 0,
            new EUR()
          )}`}
        </TableCell>
      </TableRow>
    );
  };

  public renderStatementDetailsRow = (_level: number): any => {
    return (
      <TableRow key={`details-${uuidV4()}`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontWeight: "bold",
          }}
        >
          {`${this.trans(
            "details-for-the-result"
          )} ${this.formatter.monthYearFormatDate(
            this.props.statementData?.financialStatement?.firstDate
          )}`}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderHeadersRow = (): any => {
    return (
      <TableRow key={`headers-${uuidV4()}`}>
        <TableCell style={{ width: "45" }}></TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {this.trans("title-paid")}
        </TableCell>
        <TableCell style={{ width: "13%", textAlign: "right" }}></TableCell>
        <TableCell colSpan={2} style={{ width: "28%", textAlign: "right" }}>
          {this.trans("label-amount")}
        </TableCell>
      </TableRow>
    );
  };

  public renderTotalsRow = (_level: number): any => {
    return (
      <TableRow key={`totals-${uuidV4()}`}>
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
          }}
        >
          {this.trans("totals")}
        </TableCell>
        {/* todo fix hardcoded currency */}
        <TableCell style={{ width: "14%", fontWeight: "bold" }}>
          {this.formatter.formatNumber(
            this.props.statementData.financialStatement.balance.result,
            new EUR()
          )}
        </TableCell>
        <TableCell style={{ width: "14%", fontWeight: "bold" }}>
          {this.formatter.formatNumber(
            this.props.statementData.financialStatement.balance.result +
              this.props.statementData.financialStatement.balance.amount,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderLatePaymentsRow = (_level: number): any => {
    return (
      <TableRow key={`late-payments-${uuidV4()}`}>
        <TableCell
          className="bigger-row"
          style={{
            width: "59%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
          }}
        >
          {`${this.trans("late-payments")}`}
        </TableCell>
        <TableCell style={{ width: "13%" }}></TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {this.trans("label-still-to-be-paid")}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  // JB
  // Deprecated. This function is not used anymore
  public renderCerriedFromMonthRow = (_level: number): any => {
    return (
      <TableRow key={`carried-from-previous-month-${uuidV4()}`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {`${this.trans(
            "still-to-be-received-for-month"
          )} ${this.formatter.monthYearFormatDate(
            this.props.statementData?.firstDate
          )}`}
        </TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            !!this.props.statementData?.data?.totalAmountOfReceivableCharges
              ? this.props.statementData?.data?.totalAmountOfReceivableCharges
              : 0,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderCerriedFromPreviousMonthRow = (_level: number): any => {
    return (
      <TableRow key={`carried-from-previous-month-2-${uuidV4()}`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {`${this.trans("still-to-be-received-from-the-beginning", {
            period: this.formatter.monthYearFormatDate(
              this.props.statementData?.firstDate
            ),
          })}`}
        </TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(
            this.props.statementData?.carriedFromLastMonth,
            new EUR()
          )}
        </TableCell>
      </TableRow>
    );
  };

  public renderCerriedToNextMonthRow = (owner: any, _level: number): any => {
    return (
      <TableRow key={`carried-to-next-month-${uuidV4()}`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
          }}
        >
          {`${this.trans("still-to-be-received-at-the-end", {
            period: this.formatter.monthYearFormatDate(
              this.props.statementData?.firstDate
            ),
          })}`}
        </TableCell>
        <TableCell style={{ width: "14%", textAlign: "right" }}>
          {/* todo fix hardcoded currency */}
          {this.formatter.formatNumber(owner?.carry, new EUR())}
        </TableCell>
      </TableRow>
    );
  };

  public comparer = (a: any, b: any): number => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  };

  public contractComparer = (a: any, b: any): number => {
    const contract1Id: number = a.id;
    const contractEntity1: ContractInterface = this.props.app.contracts.find(
      (contract) => contract.id === contract1Id
    );
    const contract2Id: number = b.id;
    const contractEntity2: ContractInterface = this.props.app.contracts.find(
      (contract) => contract.id === contract2Id
    );

    return this.comparer(
      contractEntity1?.firstDate,
      contractEntity2?.firstDate
    );
  };

  public unitComparer = (a: any, b: any): number => {
    return this.comparer(a?.unitNumber, b?.unitNumber);
  };

  public propertyComparer = (a: any, b: any): number => {
    const property1Id: number = a.id;
    const selectedProperty1: PropertyInterface =
      this.props.properties.byId[property1Id];
    const property2Id: number = b.id;
    const selectedProperty2: PropertyInterface =
      this.props.properties.byId[property2Id];

    return this.comparer(
      selectedProperty1?.address?.locality,
      selectedProperty2?.address?.locality
    );
  };

  public ownerComparer = (a: any, b: any): number => {
    const owner1Id: number = a.id;
    const ownerEntity1: CompanyInterface = this.props.app.companies.find(
      (company) => company.id === owner1Id
    );
    const owner2Id: number = b.id;
    const ownerEntity2: CompanyInterface = this.props.app.companies.find(
      (company) => company.id === owner2Id
    );

    return this.comparer(ownerEntity1.name, ownerEntity2.name);
  };

  public renderOwnerSavingsRow = (_level: number): any => {

    if (this.props.statementData?.savingbalance <= 0 || this.props.statementData?.savingbalance === null || this.props.statementData?.savingbalance === undefined) {
      return null;
    }
    return (
      <>
        <TableRow
          hover
          key={`details-${uuidV4()}`}
          className="bigger-row clickable-entity"
          onClick={() =>
            this.redirect(
              `/app/owner/update/${this.props.statementData?.ownerId}`
            )
          }
        >
          <TableCell
            className="bigger-row"
            style={{
              lineHeight: "24px",
              paddingLeft: `20px`,
              width: "45%",
              fontSize: "20px",
              fontWeight: "bold",
              border: 0,
            }}
          >
            {`${this.trans("owner-savings-for")}`}
          </TableCell>
          <TableCell
            style={{ width: "14%", textAlign: "right", border: 0 }}
            className="align-right"
          >
          </TableCell>
          <TableCell
            style={{ width: "13%", textAlign: "right", border: 0 }}
            className="align-right"
          ></TableCell>
          <TableCell
            colSpan={2}
            style={{ width: "28%", textAlign: "right", border: 0 }}
            className="align-right"
          >
            {this.trans("label-amount")}
          </TableCell>
        </TableRow>
      </>
    );
  };

  public renderSavingAmountRow = (_level: number, ownerId: number): any => {
    const companyId: number = ownerId;
    const companyEntity: CompanyInterface = this.props.app.companies.find(
      (company: CompanyInterface) => company.id === companyId
    );

    if (this.props.statementData?.savingbalance <= 0 || this.props.statementData?.savingbalance === null || this.props.statementData?.savingbalance === undefined) {
      return null;
    }
    return (
      <>
        <TableRow
          hover
          key={`details-${uuidV4()}`}
          className="bigger-row clickable-entity"
          onClick={() =>
            this.redirect(`/app/owner/update/${this.props.statementData?.ownerId}`)
          }
        >
          <TableCell
            className="bigger-row"
            style={{
              lineHeight: "24px",
              paddingLeft: `20px`,
              width: "45%",
              fontWeight: "bold",
              fontSize: "17px",
              border: 0,
            }}
          >
            {companyEntity.displayName}
          </TableCell>
          <TableCell
            style={{ width: "14%", textAlign: "right", border: 0 }}
            className="align-right"
          ></TableCell>
          <TableCell
            style={{ width: "13%", textAlign: "right", border: 0 }}
            className="align-right"
          ></TableCell>
          <TableCell
            colSpan={2}
            style={{ 
              width: "28%",
              textAlign: "right", 
              border: 0, 
              fontWeight: "bold",
              fontSize: "17px" 
            }}
            className="align-right"
          > 
          {
            this.formatter.formatNumber(
                  this.props.statementData?.savingbalance,
                    new EUR()
            )
          }
          {/* {companyEntity.savingsAccount} */}
          </TableCell>
        </TableRow>
      </>
    );
  };
  

  public renderOwnerStatement = (balance: any, level: number): any => {
    const owner: any = balance.data;
    const renderedRows: any = [];
    const previousPayoutCharges =
      this.props.statementData?.data?.payoutSection?.previousPayoutCharges ||
      [];
    const actualPayoutCharge =
      this.props.statementData?.data?.payoutSection?.actualPayoutCharge || {};
    const settlementCharges =
      this.props.statementData?.data?.payoutSection?.settlementCharges || [];


    // CASA-8728
    const shouldShowPaySections =
      (actualPayoutCharge?.amountPaid > 0 &&
        this.props.statementData?.data?.payoutSection?.leftToPay) ||
      (settlementCharges?.length > 0 && !actualPayoutCharge?.isPaid);
    // 10510 - Backend will not send these properties if values are 0. (Will be undefined)
    const totalAmountOfAgencyService =
      this.props.statementData?.data?.totalAmountOfAgencyService;
    const totalAmountOfAgencyServiceExclVat =
      this.props.statementData?.data?.totalAmountOfAgencyServiceExclVat;
    const shouldShowSavingsSection =
      !!this.props.statementData?.data?.savingsCharges?.length;
    const savingsCharges = this.props.statementData?.data?.savingsCharges || [];

    if (!owner) {
      return;
    }

    // JB
    // ************
    // INVOICE PART
    // ************

    // 10527 - If totalAmounts are 0 or undefined, we don't show invoice rows.
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(
        this.renderTitleRow(
          this.trans(
            totalAmountOfAgencyService < 0
              ? "title-invoice"
              : "title-credit-invoice"
          )
        )
      );
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderInvoicePeriodRow(level));
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      actualPayoutCharge?.invoiceNumber &&
      renderedRows.push(
        this.renderInvoiceNumberRow(level, actualPayoutCharge?.invoiceNumber)
      );
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderInvoiceDateRow(level));
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderEmptyRow(true, true));

    totalAmountOfAgencyService < 0 &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderTotalAmountsAgencyServiceExclVatRow(level));
    totalAmountOfAgencyService > 0 &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderTotalAmountsCreditInvoiceExclVatRow(level));
    // go through vatPercentages array to show vatPercentages lines
    if (
      totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      this.props.statementData?.data?.totalVatPercentagesOfAgencyService &&
      this.props.statementData?.data?.totalVatPercentagesOfAgencyService
        ?.length > 0
    ) {
      this.props.statementData?.data?.totalVatPercentagesOfAgencyService.forEach(
        (vatPercentage) => {
          return renderedRows.push(
            this.renderVatPercentageRow(
              level,
              vatPercentage.percentage,
              vatPercentage.totalVatAmount
            )
          );
        }
      );
    }
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderTotalToPayByOwnerRow(level));
    totalAmountOfAgencyService &&
      totalAmountOfAgencyServiceExclVat &&
      renderedRows.push(this.renderEmptyRow(true, true));

    // **************
    // STATEMENT PART
    // **************

    // *******************************************
    // PAYOUT - RESULT SECTION 
    // Total receivables paid minus total payables
    // *******************************************

    renderedRows.push(this.renderTitleRow(this.trans("settlement")));
    renderedRows.push(this.renderSummaryRow(level));
    renderedRows.push(this.renderTotalIncomeRow(level));
    renderedRows.push(this.renderTotalExpensesRow(level));
    renderedRows.push(this.renderResultRow(level));

    // ****************************************
    // PAYOUT - SAVINGS SECTION 
    // Owner's savings deposits and withdrawals 
    // ****************************************

    shouldShowSavingsSection &&
      renderedRows.push(this.renderEmptyRow(false, true));
    shouldShowSavingsSection &&
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/savings"),
          level
        )
      );
    shouldShowSavingsSection &&
      savingsCharges?.length > 0 &&
      savingsCharges.forEach((charge) =>
        renderedRows.push(this.renderSavingsChargeRow(charge, level))
      );

    // ***************************************
    // PAYOUT - PREVIOUS PAYOUTS SECTION
    // Previous payout charges for this period
    // ***************************************

    previousPayoutCharges?.length > 0 &&
      renderedRows.push(this.renderEmptyRow(false, true));
    previousPayoutCharges?.length > 0 &&
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/previouspayoutcharges", {
            period: Time.useFormat(
              this.props.statementData?.firstDate,
              "MMMM YYYY"
            ),
          }),
          level
        )
      );
    previousPayoutCharges?.length > 0 &&
      previousPayoutCharges.forEach((charge, index) =>
        renderedRows.push(this.renderPreviousPayoutRow(charge, index, level))
      );

    // ******************************
    // PAYOUT - PAYOUT CHARGE SECTION
    // This statement's payout charge 
    // ******************************

    actualPayoutCharge && renderedRows.push(this.renderEmptyRow(false, true));
    actualPayoutCharge &&
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/newactualpayoutcharge", {
            period: Time.useFormat(
              this.props.statementData?.firstDate,
              "MMMM YYYY"
            ),
          }),
          level
        )
      );
    actualPayoutCharge &&
      renderedRows.push(this.renderActualPayoutRow(actualPayoutCharge, level));

    // ********************************************************************
    // PAYOUT - ALREADY PAID SECTION
    // Amounts already paid/settled with the payout charges for this period
    // ********************************************************************

    ( actualPayoutCharge?.payments.length > 0 ) &&
      renderedRows.push(this.renderEmptyRow(false, true));
    ( actualPayoutCharge?.payments.length > 0 ) &&
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/ofwhichsettled"),
          level
        )
      );

   if (actualPayoutCharge?.payments?.length > 0 ) {
    actualPayoutCharge?.payments?.length > 0 &&
      actualPayoutCharge?.payments.forEach((payment) =>
        renderedRows.push(this.renderSettledPaymentRow(payment, level))
      );
    }
    
    // ***********************************************
    // PAYOUT - TO SETTLE WITH SECTION
    // Unpaid charges to settle with the payout charge
    // ***********************************************

    const settlementSection = [];
    settlementCharges.forEach((charge) => {
      if (charge.ownerId === charge.companyId) {
        settlementSection.push(charge);
      }
    })

    // shouldShowPaySections &&
    //   settlementCharges?.length > 0 &&
    //   renderedRows.push(this.renderEmptyRow(false, true));
    // shouldShowPaySections &&
    //   settlementCharges?.length > 0 &&
    //   renderedRows.push(
    //     this.renderPayoutSectionTitleRow(
    //       this.trans("payout-section-title/settlements"),
    //       level
    //     )
    //   );

    if ((shouldShowPaySections && settlementCharges?.length > 0) || settlementSection?.length > 0) {
    renderedRows.push(this.renderEmptyRow(false, true));
          renderedRows.push(
                this.renderOwnerPayoutSectionTitleRow(
                  this.trans("payout-section-title/settlements"),
                  level, 
                  settlementCharges
        )
      );
    }

    // JB
    // Not clear why Ornat replace commented code below with the code under it.
    // shouldShowPaySections &&
    //   settlementCharges?.length > 0 &&
    // settlementCharges.forEach((charge) =>
    //   renderedRows.push(this.renderSettlementChargeRow(charge, level))
    // );
      if (shouldShowPaySections &&
        settlementCharges?.length > 0) {
        settlementCharges.forEach((charge) => {
          if (charge?.ownerId === this.props.statementData?.ownerId || charge?.ownerId === charge?.companyId ) {
          renderedRows.push(this.renderSettlementChargeRow(charge, level))
          }
          }
        );
      } 
      else if (settlementCharges?.length > 0) {
          settlementCharges.forEach((charge) => {
            if (charge.ownerId === charge.companyId) {
              renderedRows.push(this.renderSettlementChargeRow(charge, level));
            }
          }
        );
      }

    // **************************************************************
    // PAYOUT - LEFT TO PAY SECTION
    // The payout charge amount minus the charges that can be settled
    // **************************************************************

    (actualPayoutCharge?.amountPaid > 0 || settlementCharges?.length > 0) &&
      renderedRows.push(this.renderEmptyRow(false, true));
    (actualPayoutCharge?.amountPaid > 0 || settlementCharges?.length > 0) &&
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/topay"),
          level
        )
      );
    (actualPayoutCharge?.amountPaid > 0 || settlementCharges?.length > 0) &&
      renderedRows.push(this.renderLeftToPayRow(level));

    renderedRows.push(this.renderEmptyRow(false, true));


    // ***************
    // DETAILS SECTION
    // ***************

    // JB
    // Render the header for the details section
    renderedRows.push(this.renderDetailsRow(level));
   
    // renderedRows.push(this.renderHeadersRow());
    // renderedRows.push(this.renderStatementCompanyRow(level));

    if (!!owner.charges && owner.charges.length !== 0) {
      this.renderCharge(owner.charges, level).forEach((chargeRow) =>
        renderedRows.push(chargeRow)
      );
    }

    !!owner.properties &&
      owner.properties
        .filter((property) => !!property)
        .sort(this.propertyComparer)
        .forEach((property) => {
          if (
            !!property.charges &&
            property.charges.length === 0 &&
            property.units.every((unit) => {
              if (!unit) {
                return true;
              }

              return (
                !!unit.charges &&
                unit.charges.length === 0 &&
                (unit.contracts.length === 0 ||
                  unit.contracts.every((contract) => {
                    if (!contract) {
                      return true;
                    }

                    return !!contract.charges && contract.charges.length === 0;
                  }))
              );
            })
          ) {
            return;
          }

          const propertyRow: any = this.renderPropertyRow(level, property);
          renderedRows.push(propertyRow);
         
          this.renderPropertyBalance(property, level).forEach((row) =>
            renderedRows.push(row)
          );
        });

    if (balance.totalAmount && balance.totalAmountPaid) {
      renderedRows.push(this.renderTotalsRow(level));
    }

    const hasLatePayments =
      typeof balance?.data?.latePaymentCharges?.owner === "object" &&
      balance?.data?.latePaymentCharges?.owner !== null &&
      Object.keys(balance?.data?.latePaymentCharges?.owner || {}).length > 0 &&
      (balance?.data?.latePaymentCharges?.owner?.charges?.length > 0 ||
        (balance?.data?.latePaymentCharges?.owner?.properties?.length > 0 &&
          !!balance?.data?.latePaymentCharges?.owner?.properties.some(
            (property) => {
              if (!property) {
                return true;
              }

              if (
                !!property.charges &&
                property.charges.length === 0 &&
                property.units.every((unit) => {
                  if (!unit) {
                    return true;
                  }

                  return (
                    !!unit.charges &&
                    unit.charges.length === 0 &&
                    (unit.contracts.length === 0 ||
                      unit.contracts.every((contract) => {
                        if (!contract) {
                          return true;
                        }

                        if (
                          !!contract.charges &&
                          contract.charges.length === 0
                        ) {
                          return true;
                        }
                      }))
                  );
                })
              ) {
                return false;
              }

              return true;
            }
          )));

    if (hasLatePayments) {
      renderedRows.push(this.renderEmptyRow(true));
      renderedRows.push(this.renderLatePaymentsRow(level));
      this.renderCharge(
        balance?.data?.latePaymentCharges?.owner?.charges,
        level,
        true
      ).forEach((chargeRow) => renderedRows.push(chargeRow));

      !!balance?.data?.latePaymentCharges?.owner?.properties
        .filter((property) => !!property)
        .sort(this.propertyComparer)
        .forEach((property) => {
          if (
            !!property.charges &&
            property.charges.length === 0 &&
            property.units.every((unit) => {
              if (!unit) {
                return true;
              }

              return (
                !!unit.charges &&
                unit.charges.length === 0 &&
                (unit.contracts.length === 0 ||
                  unit.contracts.every((contract) => {
                    if (!contract) {
                      return true;
                    }

                    return !!contract.charges && contract.charges.length === 0;
                  }))
              );
            })
          ) {
            return;
          }

          // const propertyRow: any = this.renderPropertyRow(level, property);
          // renderedRows.push(propertyRow);

          this.renderPropertyBalance(property, level, true).forEach((row) =>
            renderedRows.push(row)
          );
        });
    }

    renderedRows.push(this.renderEmptyRow());
    renderedRows.push(this.renderOwnerSavingsRow(level));
    renderedRows.push(this.renderSavingAmountRow(level, balance?.data?.payoutSection?.actualPayoutCharge?.companyId));

    // render carry info
    // CASA-8086
    // (this.props.statementData?.data?.totalAmountOfReceivableCharges || this.props.statementData?.carriedFromLastMonth) && renderedRows.push(this.renderToBeReceivedRow(level));
    // (this.props.statementData?.data?.totalAmountOfReceivableCharges || this.props.statementData?.carriedFromLastMonth) && renderedRows.push(this.renderCerriedFromPreviousMonthRow(level));
    // this.props.statementData?.carriedFromLastMonth && renderedRows.push(this.renderCerriedFromMonthRow(level));
    // (this.props.statementData?.data?.totalAmountOfReceivableCharges || this.props.statementData?.carriedFromLastMonth) && renderedRows.push(this.renderCerriedToNextMonthRow(owner, level));

    return renderedRows;
  };

  public renderAgencyStatement = (balance: any, level: number): any => {
    const renderedRows: any = [];
    const actualPayoutCharge =
      this.props.statementData?.data?.payoutSection?.actualPayoutCharge || {};
    // const settlementCharges =
    //   this.props.statementData?.data?.payoutSection?.settlementCharges || [];
    // const shouldShowPaySections =
    //   !!this.props.statementData?.data?.payoutSection?.leftToPay;
    const depositedAmount =
      this.props.statementData?.data?.payoutSection?.depositedAmount || 0;
    const withdrawnAmount =
      this.props.statementData?.data?.payoutSection?.withdrawnAmount || 0;

    renderedRows.push(this.renderTitleRow(this.trans("settlement")));
    renderedRows.push(this.renderSummaryRow(level));
    renderedRows.push(this.renderTotalAgencyIncomeRow(level));
    renderedRows.push(this.renderTotalAgencyExpensesRow(level));
    renderedRows.push(this.renderResultRow(level));
    
    // Savings section
    // if (!!balance.data && balance.data.length !== 0) {
    //   renderedRows.push(this.renderEmptyRow(false, true));
    //   renderedRows.push(
    //     this.renderPayoutSectionTitleRow(
    //       this.trans("payout-section-title/savings"),
    //       level
    //     )
    //   );
      // this.props.statementData?.data?.payoutSection?.savingsCharges.forEach((charge) => {
      //   renderedRows.push(this.renderSavingsChargeRow(charge, level))
      // })
    // }

    actualPayoutCharge && renderedRows.push(this.renderEmptyRow(false, true));
    actualPayoutCharge &&
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/newactualpayoutcharge", {
            period: Time.useFormat(
              this.props.statementData?.firstDate,
              "MMMM YYYY"
            ),
          }),
          level
        )
      )
    actualPayoutCharge &&
      renderedRows.push(this.renderActualPayoutRow(actualPayoutCharge, level));

    // shouldShowPaySections &&
    //   settlementCharges?.length > 0 &&
    //   renderedRows.push(this.renderEmptyRow(false, true));
    // shouldShowPaySections &&
    //   settlementCharges?.length > 0 &&
    //   renderedRows.push(
    //     this.renderPayoutSectionTitleRow(
    //       this.trans("payout-section-title/settlements"),
    //       level
    //     )
    //   );
    // shouldShowPaySections &&
    //   settlementCharges?.length > 0 &&
    //   settlementCharges.forEach((charge) =>
    //     renderedRows.push(this.renderSettlementChargeRow(charge, level))
    //   );
    // Payout Section
    // shouldShowPaySections &&
    //   actualPayoutCharge?.payments?.length > 0 &&
    //   renderedRows.push(this.renderEmptyRow(false, true));
    // shouldShowPaySections &&
    //   actualPayoutCharge?.payments?.length > 0 &&
    //   renderedRows.push(
    //     this.renderPayoutSectionTitleRow(
    //       this.trans("payout-section-title/ofwhichsettled"),
    //       level
    //     )
    //   );
    // shouldShowPaySections &&
    //   actualPayoutCharge?.payments?.length > 0 &&
    //   actualPayoutCharge?.payments.forEach((payment) =>
    //     renderedRows.push(this.renderSettledPaymentRow(payment, level))
    //   );

    !!depositedAmount && renderedRows.push(this.renderEmptyRow(false, true));
    !!depositedAmount &&
      renderedRows.push(
        this.renderSubsectionTitleRow(this.trans("deposited_title"))
      );
      
      !!balance.data.owners &&
      balance.data.owners
        .filter((owner) => !!owner)
        .sort(this.ownerComparer)
        .forEach((owner) => {
          owner?.properties?.forEach((property) => {
            if (property) {
              property?.units?.forEach((unit) => {
                if (unit) {
                  unit.charges.forEach((charge) => {
                    if (charge) {
                      charge.payments.forEach((payment) => {
                        if (payment && payment.paymentTypeId === 8 && payment.paymentClassId === 2) {
                          renderedRows.push(this.renderDepositeAndWithdrawalPaymentRow(payment, true, level, property))
                        }
                      })
                    }
                  })
                }
              })
            }
        })
      })
    !!depositedAmount && depositedAmount > 0 &&
      renderedRows.push(
        this.renderAmountRow(
          depositedAmount,
          this.trans("deposited_row_description"),
          level
        )
      );
    if (this.props.statementData?.data?.payoutSection?.withdrawal.length > 0) {
    !!withdrawnAmount && renderedRows.push(this.renderEmptyRow(false, true));
    !!withdrawnAmount &&
      renderedRows.push(
        this.renderSubsectionTitleRow(this.trans("withdrawn_title"))
      );
      this.props.statementData?.data?.payoutSection?.withdrawal.forEach((payment) => {
        renderedRows.push(this.renderDepositeAndWithdrawalPaymentRow (payment, false, level));
      })
    }
    !!this.props.statementData?.data?.payoutSection?.withdrawalChargesSum &&
      renderedRows.push(
        this.renderAmountRow(
          this.props.statementData?.data?.payoutSection?.withdrawalChargesSum,
          this.trans("withdrawal_row_description"),
          level
        )
      );
    if (!!balance.data && balance.data.length !== 0 && this.props.statementData?.data?.payoutSection?.agencyChargeAmount > 0) {
      renderedRows.push(this.renderEmptyRow(false, true));
      renderedRows.push(
        this.renderSubsectionTitleRow(this.trans("agency_charges_title"))
      );
      this.renderAgencyCharges(balance.data.charges, level).forEach(
        (chargeRow) => renderedRows.push(chargeRow)
      );
    }
    if (!!balance.data && balance.data.length !== 0 && balance.data.charges.length > 0 && this.props.statementData?.data?.payoutSection?.agencyAlreadyPainChargeAmount > 0) {
      this.renderAlreadyPaidAgencyCharges(balance.data.charges, level).forEach(
        (chargeRow) => renderedRows.push(chargeRow)
      );
    }


      renderedRows.push(this.renderEmptyRow(false, true));
      renderedRows.push(
        this.renderPayoutSectionTitleRow(
          this.trans("payout-section-title/topay"),
          level
        )
      );
    renderedRows.push(this.renderLeftToPayRow(level));
    // Details section
    renderedRows.push(this.renderEmptyRow(false, true));
    renderedRows.push(this.renderDetailsRow(level));

    // renderedRows.push(this.renderStatementCompanyRow(level));
    // renderedRows.push(this.renderTotalExpensesRow(level));
    // renderedRows.push(this.renderStatementDetailsRow(level));
    // renderedRows.push(this.renderHeadersRow());

    if (!!balance.data && balance.data.length !== 0) {
      this.renderAgencyChargesDetailsSection(balance.data.charges, level).forEach(
        (chargeRow) => renderedRows.push(chargeRow)
      );
    }

    !!balance.data.owners &&
      balance.data.owners
        .filter((owner) => !!owner)
        .sort(this.ownerComparer)
        .forEach((owner) => {
          let ownerObject = JSON.parse(JSON.stringify(owner));
          let hasOwnerChargers = owner?.charges && owner?.charges?.length > 0;

          owner?.properties?.forEach((property, indexProperty) => {
            let hasPropertiesCharges =
              property?.charges && property?.charges?.length > 0;

            property?.units?.forEach((unit, indexUnit) => {
              if (unit?.charges && unit?.charges?.length > 0) {
                hasPropertiesCharges = true;
              } else {
                ownerObject.properties[indexProperty].units[indexUnit] = null;
              }
            });

            if (hasPropertiesCharges) {
              hasOwnerChargers = true;
            } else {
              ownerObject.properties[indexProperty] = null;
            }
          });

          if (hasOwnerChargers) {
            const ownerRow: any = this.renderOwnerRow(level, owner.id);
            renderedRows.push(ownerRow);
            this.renderOwnerBalance(ownerObject, level).forEach((row) =>
              renderedRows.push(row)
            );
          }

          // if (!!owner.charges && owner.charges.length === 0 &&
          //     owner.properties.every(property => {
          //       if (!property) {
          //         return  true;
          //       }
          //
          //       return !!property.charges && property.charges.length === 0 && property.units.every(unit => {
          //         if (!unit) {
          //           return true;
          //         }
          //
          //         return !!unit.charges && unit.charges.length === 0 && (unit.contracts.length === 0 || unit.contracts.every(contract => {
          //           if (!contract) {
          //             return true;
          //           }
          //
          //           return !!contract.charges && contract.charges.length === 0
          //         }))
          //       })
          //     })
          // ) {
          //   return;
          // }
        });

    return renderedRows;
  };

  public renderAgencyCharges = (charges: any, _level: number): any => {
    const renderedRows: any[] = [];
    charges.forEach((entry) => {
      // const renderedCounterpartyRow = this.renderCounterpartyRow(entry[0].name);
      // renderedRows.push(renderedCounterpartyRow);
      entry.forEach((charge) => {
        if (charge?.payments[0]?.name === "") {
          this.renderCharge([charge], _level).forEach((chargeRow) =>
            renderedRows.push(chargeRow)
          );
        }
      });
    });

    return renderedRows;
  };

  public renderAgencyChargesDetailsSection = (charges: any, _level: number): any => {
    const renderedRows: any[] = [];
    charges.forEach((entry) => {
      const renderedCounterpartyRow = this.renderCounterpartyRow(entry[0].name);
      renderedRows.push(renderedCounterpartyRow);
      entry.forEach((charge) => {
        if (charge?.payments[0]?.name !== "") {
          this.renderCharge([charge], _level).forEach((chargeRow) =>
            renderedRows.push(chargeRow)
          );
        }
      });
    });

    return renderedRows;
  };

  public renderAlreadyPaidAgencyCharges = (charges: any, _level: number): any => {
    const renderedRows: any[] = [];
    renderedRows.push(this.renderEmptyRow(false, true));
    renderedRows.push(
      this.renderSubsectionTitleRow(this.trans("agency_charges_already_pay_title"))
    );
    charges.forEach((entry) => {
      // const renderedCounterpartyRow = this.renderCounterpartyRow(entry[0].name);
      // renderedRows.push(renderedCounterpartyRow);
      entry.forEach((charge) => {
        if (charge?.payments[0]?.name === "" && charge?.amount === charge?.amountPaid) {
          this.renderAlreadyPaidCharge([charge], _level).forEach((chargeRow) =>
            renderedRows.push(chargeRow)
          );
        }
      });
    });

    return renderedRows;
  };

  public renderCounterpartyRow = (counterparty: string): any => {
    return (
      <TableRow
        hover
        key={`contract-${counterparty}-${uuidV4()}`}
        className={`clickable-entity no-border-bottom has-border-top small-height bottom-padding`}
      >
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            paddingBottom: "0px",
          }}
        >
          {counterparty}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderSubsectionTitleRow = (title: string): any => {
    return (
      <TableRow key={`summary-${uuidV4()}`} className={`small-height`}>
        <TableCell
          colSpan={3}
          style={{
            width: "86%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            fontSize: "15px",
            fontStyle: "italic",
          }}
        >
          {title}
        </TableCell>
        <TableCell style={{ width: "14%" }}></TableCell>
      </TableRow>
    );
  };

  public renderAmountRow(amount: number, lineText: string, _level: number) {
    return (
      <TableRow
        key={`left-to-paid-received-by-owner-${uuidV4()}`}
        className="left-to-pay-row no-border-bottom small-height"
      >
        <TableCell
          colSpan={2}
          style={{
            width: "72%",
            // paddingLeft: `${20 * level}px`,
            paddingLeft: `20px`,
            paddingRight: "5px",
            fontWeight: "bold",
            fontSize: "15px",
          }}
        >
          {lineText}
        </TableCell>
        <TableCell
          colSpan={2}
          style={{
            width: "28%",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: "19px",
          }}
        >
          {/* todo fix hardcoded currency */}
          {`${this.formatter.formatNumber(amount, new EUR())}`}
        </TableCell>
      </TableRow>
    );
  }

  public renderDetailsTable = (): any => {
    if (this.props.isAgencyStatement) {
      return this.renderAgencyStatement(this.props.statementData, 1);
    }

    return this.renderOwnerStatement(this.props.statementData, 1);
  };

  public openMemoPopup = (unit: UnitInterface) => {
    this.setState({
      currentUnit: unit,
      note: unit.note,
      memoPopupOpen: true,
      anchorElUnits: null,
    });
  };
  public saveDraft = (message) => {
    this.setState({
      note: message,
    });
  };

  public saveReminder = (unit: UnitInterface) => {
    this.saving(() => {
      if (this.state.note) {
        return this.props.dispatch({
          type: Constants.GLOBAL_UNIT_UPDATE_START,
          payload: {
            id: unit && unit.id,
            unit: {
              note: this.state.note,
            },
          },
          onSuccess: () =>
            this.setState({ isSaving: false, memoPopupOpen: false }),
          onError: () => {
            this.setState({ isSaving: false });

            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("memo-can-not-be-longer-than-255"),
                type: "warning",
              },
            });
          },
        });
      } else {
        this.setState({ isSaving: false, memoPopupOpen: false });
      }
    });
  };

  public removeReminder = (unit: UnitInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: "",
          },
        },
        onSuccess: () =>
          this.setState({ isSaving: false, memoPopupOpen: false }),
        onError: () => this.setState({ isSaving: false }),
      });
    });
  };

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  };

  public render() {
    return (
      <div>
        <TableComponent
          {...this.props}
          className="child-listing-table balance-table"
          rows={this.renderDetailsTable()}
          noPagination={true}
        />

        <ChargeUpdateDialog
          isOpened={this.state.isChargeUpdatePopupOpen}
          title={this.trans("page/chargeupdate-title")}
          isInvoice={true}
          charge={this.state.selectedCharge}
          onCancel={this.closeChargeUpdatePopup}
          {...this.props}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo
                {...this.props}
                entity={this.state.currentUnit}
                saveDraft={this.saveDraft}
                unit={this.state.currentUnit}
                relations={{ unitId: this.state.currentUnit?.id }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.currentUnit)}
          hideCross={true}
          subtitle={
            this.state.currentUnit?.displayName
              ? this.state.currentUnit?.displayName
              : ""
          }
        />
      </div>
    );
  }
}

export { StatementDataRenderer };
